function buildPageUrl(rawValue, pageValue) {
  const url = new URL(rawValue, window.location.origin);
  url.searchParams.set("page", pageValue);
  url.searchParams.delete("phcursor");
  return url.pathname + "?" + url.searchParams.toString();
}

function getListClass(destinationGrid, sourceGrid) {
  const existing = destinationGrid.querySelector(".collection-product-list");
  if (existing) return existing.className;
  const sourceList = sourceGrid.querySelector(".collection-product-list");
  return sourceList ? sourceList.className : "collection-product-list";
}

function isBrandGroupingGrid(grid) {
  return (
    grid?.classList?.contains("collection-product-groups") ||
    Object.prototype.hasOwnProperty.call(grid?.dataset || {}, "mainBrandHandle")
  );
}

function getBrandHeaders(...containers) {
  const meta = {};
  containers
    .filter(Boolean)
    .forEach((container) => {
      container.querySelectorAll(".collection-product-brand").forEach((group) => {
        const handle = group.dataset.vendor || "no-brand";
        const header = group.querySelector(".collection-product-brand__header");
        if (header && !meta[handle]) {
          meta[handle] = header.outerHTML;
        }
      });
    });
  return meta;
}

function collectItems(container, sourceGrid) {
  const items = Array.from(
    container.querySelectorAll(".collection-product-list-item")
  );
  if (sourceGrid) {
    items.push(
      ...Array.from(
        sourceGrid.querySelectorAll(".collection-product-list-item")
      )
    );
  }
  return items;
}

function regroupBrands(destinationGrid, sourceGrid) {
  if (!destinationGrid) return;

  const listClass = getListClass(destinationGrid, sourceGrid);
  const brandHeaders = getBrandHeaders(destinationGrid, sourceGrid);
  const items = collectItems(destinationGrid, sourceGrid);
  const mainHandle = destinationGrid.dataset.mainBrandHandle || "";

  const grouped = {};
  items.forEach((item) => {
    const handle = item.dataset.vendorHandle || "no-brand";
    const title = item.dataset.vendorTitle || handle;
    if (!grouped[handle]) {
      grouped[handle] = { title, items: [] };
    }
    grouped[handle].items.push(item);
  });

  const handles = Object.keys(grouped).sort((a, b) => {
    if (a === mainHandle) return -1;
    if (b === mainHandle) return 1;
    return grouped[a].title.localeCompare(grouped[b].title);
  });

  const fragment = document.createDocumentFragment();
  handles.forEach((handle) => {
    const data = grouped[handle];
    const group = document.createElement("div");
    group.className = "collection-product-brand";
    if (handle === mainHandle) {
      group.classList.add("collection-product-brand--main");
      group.dataset.mainBrand = "true";
    }
    group.dataset.vendor = handle;

    const headerHTML = brandHeaders[handle];
    if (headerHTML) {
      group.insertAdjacentHTML("afterbegin", headerHTML);
    } else {
      const header = document.createElement("div");
      header.className = "collection-product-brand__header";
      header.innerHTML = `<h3 class="collection-product-brand__title h4">${data.title}</h3>`;
      group.appendChild(header);
    }

    const list = document.createElement("ul");
    list.className = listClass;
    data.items.forEach((productItem) => {
      list.appendChild(productItem);
    });
    group.appendChild(list);
    fragment.appendChild(group);
  });

  destinationGrid.innerHTML = "";
  destinationGrid.appendChild(fragment);
  initBrandDescriptionToggles(destinationGrid);
}

function initBrandDescriptionToggles(root = document) {
  root.querySelectorAll(".js-brand-desc-toggle").forEach((button) => {
    if (button.dataset.bound === "true") return;
    button.dataset.bound = "true";
    button.addEventListener("click", () => {
      const brand = button.closest(".collection-product-brand");
      const desc = brand?.querySelector(".collection-product-brand__description");
      const expanded = button.getAttribute("aria-expanded") === "true";
      const next = !expanded;
      button.setAttribute("aria-expanded", String(next));
      if (brand) {
        brand.classList.toggle("collection-product-brand--desc-open", next);
      }
      if (desc) {
        desc.hidden = !next;
      }
    });
  });
}

function loadItems(button) {
  if (window.brandPrefetching) return;

  const totalPages = parseInt(
    document.querySelector("[data-total-pages]").value,
    10
  );
  let currentPage = parseInt(
    document.querySelector("[data-current-page]").value,
    10
  );
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  const rawValue = document.querySelector("[data-next-url]").value;

  const nextUrl = buildPageUrl(rawValue, currentPage);
  const nextUrlScroll = buildPageUrl(rawValue, currentPageScroll);

  document.querySelector("[data-current-page]").value = currentPage;

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      const destinationGrid = document.querySelector(".load-more-grid");
      const sourceGrid = doc.querySelector(".load-more-grid");

      if (destinationGrid && sourceGrid) {
        if (isBrandGroupingGrid(destinationGrid)) {
          regroupBrands(destinationGrid, sourceGrid);
        } else {
          destinationGrid.insertAdjacentHTML("beforeend", sourceGrid.innerHTML);
        }
        initBrandDescriptionToggles(destinationGrid);
        colorSwatches();
      }
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      button.removeAttribute("disabled");
      button.classList.remove("loading");
    })
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          const currentPageInput = scrollData.querySelector(
            "input[data-current-page]"
          );

          if (nextUrlInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
          }

          if (currentPageInput) {
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (currentPage === totalPages) {
          button.remove();
        }
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

async function prefetchAllBrandGroups() {
  const destinationGrid = document.querySelector(".load-more-grid");
  const rawValue = document.querySelector("[data-next-url]")?.value;
  const totalPages = parseInt(
    document.querySelector("[data-total-pages]")?.value || "1",
    10
  );
  const currentPage = parseInt(
    document.querySelector("[data-current-page]")?.value || "1",
    10
  );

  if (!destinationGrid || !rawValue || !isBrandGroupingGrid(destinationGrid))
    return;
  if (!totalPages || totalPages <= 1 || currentPage >= totalPages) return;
  if (window.brandPrefetching) return;

  window.brandPrefetching = true;

  try {
    const aggregateGrid = document.createElement("div");

    for (let page = currentPage + 1; page <= totalPages; page += 1) {
      const pageUrl = buildPageUrl(rawValue, page);
      try {
        const response = await fetch(pageUrl);
        if (!response.ok) continue;
        const responseHTML = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, "text/html");
        const pageGrid = doc.querySelector(".load-more-grid");
        if (pageGrid) {
          pageGrid
            .querySelectorAll(".collection-product-brand")
            .forEach((group) => {
              aggregateGrid.appendChild(group);
            });
        }
      } catch (error) {
        console.error("Error prefetching page", error);
      }
    }

    if (aggregateGrid.childElementCount > 0) {
      regroupBrands(destinationGrid, aggregateGrid);
      initBrandDescriptionToggles(destinationGrid);
      colorSwatches();

      document
        .querySelectorAll(".js-infinite-scroll, .js-load-more")
        .forEach((el) => {
          el.remove();
        });

      const currentPageInput = document.querySelector("[data-current-page]");
      if (currentPageInput) currentPageInput.value = totalPages;

      const totalPagesInput = document.querySelector("[data-total-pages]");
      if (totalPagesInput) totalPagesInput.value = totalPages;
    }
  } finally {
    window.brandPrefetching = false;
  }
}

loadMore();
prefetchAllBrandGroups();
initBrandDescriptionToggles();
